import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import useStore from "../../../context/useStore";
import { quotationActions } from "../../../context/actions/quotationActions";
import Loader from "../../common/Loader";
import CustomPagination from "../../common/CustomPagination";
import CustomList from "../../common/CustomList";
import { api_url } from "../../../config/config";
import Axios from "axios";
import QuotationSearch from "./QuotationSearch/QuotationSearch";
import tools from "../../../helpers/tools";
import Can from "../../common/Can/Can";
import { userAccessEnum } from "../../../config/accessEnum";
import { useAtom } from "jotai";
import { quotationSearchAtom } from "./QuotationSearch/useQuotationSearch";
import DossierCard from "./DossierCard";
import { num } from "./DossierDashboard/formatters";
import styles from "./QuotationList.module.scss";

const MARGIN_HIDDEN_ROLES = ["COMMERCIAL_JUNIOR", "COMMERCIAL_SENIOR"];
const ITEMS_PER_PAGE = 15; // aligné sur CustomPagination (itemsCountPerPage)

const QuotationList = (props) => {
  const [state, dispatch] = useStore();

  var quotationData = state.quotation.items;

  var actions = quotationActions(state, dispatch, props);
  const [quotationSearch, setQuotationSearch] = useAtom(quotationSearchAtom);

  const hideMargins = MARGIN_HIDDEN_ROLES.includes(state.auth.user?.role);
  const marginRateMin = num(state.constant.items.MARGIN_RATE_MIN);

  function removeQuotation(id) {
    if (
      window.confirm("Êtes-vous certain de vouloir supprimer cette entrée ?")
    ) {
      Axios.delete(api_url + "quotations/" + id)
        .then((res) => {
          actions.getQuotations();
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            alert(err.response.data.message);
          }
        });
    }
  }

  useEffect(() => {
    actions.getQuotations(quotationSearch);
  }, []);

  const total = state.quotation.total;
  const pageCount = Math.max(1, Math.ceil(total / ITEMS_PER_PAGE));
  const currentPage = parseInt(quotationSearch.page || "1");

  return (
    <CustomList getAction={actions.getQuotations}>
      {(activePage, handlePageParamsChange, search) => (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className={styles.page}>
                <div className={styles.headCard}>
                  <div className={styles.headLeft}>
                    <div className={styles.icoSquare}>D</div>
                    <div>
                      <h1 className={styles.headTitle}>Dossiers</h1>
                      <div className={styles.headSub}>
                        {total > 0
                          ? `${total} ${tools.getStringPlural(
                              "dossier",
                              total > 1
                            )} · page ${currentPage} sur ${pageCount}`
                          : "Aucun dossier"}
                      </div>
                    </div>
                  </div>
                  <Can I={userAccessEnum.CREER_DOSSIER}>
                    <Link className={styles.createBtn} to="/quotations/create">
                      <i className="fa fa-plus" /> Créer un dossier
                    </Link>
                  </Can>
                </div>

                <QuotationSearch
                  handlePageParamsChange={actions.getQuotations}
                />

                {state.quotation.isLoading ? (
                  <Loader />
                ) : quotationData.length === 0 ? (
                  <div className={styles.empty}>
                    <i className="fa fa-folder-open" />
                    Aucun dossier ne correspond à votre recherche
                  </div>
                ) : (
                  quotationData.map((quotation, k) => (
                    <DossierCard
                      key={"dossier-" + (quotation.uuid || k)}
                      quotation={quotation}
                      statusConstants={state.constant.items.QUOTATION_STATUS || []}
                      hideMargins={hideMargins}
                      marginRateMin={marginRateMin}
                      onDelete={removeQuotation}
                    />
                  ))
                )}

                <div className={styles.paginationWrap}>
                  <CustomPagination
                    total={state.quotation.total}
                    activePage={quotationSearch.page || "1"}
                    handlePageParamsChange={(data) => {
                      actions.getQuotations({ ...quotationSearch, ...data });
                      setQuotationSearch({ ...quotationSearch, ...data });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </CustomList>
  );
};

export { default as RoleBadge } from "../../common/RoleBadge";

export default QuotationList;
